// extracted by mini-css-extract-plugin
module.exports = {"item":"content-grid-item_item__eDlnv"};